import React from 'react';
import './PassportSelect.scss';
import { useDispatch, useSelector } from 'react-redux';
import { changePassportType } from '../../actions/Actions';
import new_passport from '../../shared/images/new_passport.jpg';
import old_passport from '../../shared/images/old_passport.jpg';

export const PassportSelect = () => {
  const { selectedPassportType, lang } = useSelector(
    (state) => state.mainState
  );

  const dispatch = useDispatch();
  const handlechange = (evt) => {
    if (evt.currentTarget.id === 'new_pass_id') {
      dispatch(changePassportType(1));
    }
    if (evt.currentTarget.id === 'old_pass_id') {
      dispatch(changePassportType(2));
    }
  };

  return (
    <div className="passport-select">
      <div className="headerPassportSelect">
        {lang === 'tj'
          ? 'Намуди шиносномаро интихоб кунед'
          : 'Выберите образец паспорта'}
      </div>
      <div className="row radio-inputs">
        <label
          htmlFor="new_pass_id"
          className={`${selectedPassportType === 1 ? 'box-pass-2' : 'box'}`}
        >
          <span className="circle">
            <div className="d-flex justify-content-around mb-2">
              <input
                type="radio"
                name="old_pass"
                id="new_pass_id"
                className="test"
                onChange={(evt) => handlechange(evt)}
                onClick={(evt) => handlechange(evt)}
                checked={selectedPassportType === 1}
              />
              <span className="mt-4 mr-2">
                {lang === 'tj' ? 'Пластикӣ' : 'Пластиковый'}
              </span>
            </div>
            <div className="row justify-content-center">
              <img src={new_passport} alt="imag" className="template-image-1" />
            </div>
          </span>
        </label>
        <label
          htmlFor="old_pass_id"
          className={`${selectedPassportType === 2 ? 'box-pass-1' : 'box'}`}
        >
          <span className="circle">
            <div className="d-flex justify-content-around mb-2">
              <input
                type="radio"
                name="new_pass"
                id="old_pass_id"
                className="test"
                onClick={(evt) => handlechange(evt)}
                onChange={(evt) => handlechange(evt)}
                checked={selectedPassportType === 2}
              />
              <span className="mt-4 mr-2">
                {lang === 'tj' ? 'Қоғазӣ' : 'Бумажный'}
              </span>
            </div>
            <div className="row justify-content-center">
              <img src={old_passport} alt="imag" className="template-image-2" />
            </div>
          </span>
        </label>
      </div>
    </div>
  );
};
